import { axiosInstance } from '../api';

export default function() {
    return axiosInstance.get('/api/study/affiliated');
}
